import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';

/**
 * State segment to track which content attributes have been edited.
 * Format: { "contentId": { "optionId": ["attribute_name1", "attribute_name2"] } }
 *
 * Example:
 * {
 *   "content-123": {
 *     "option-456": ["header", "body"],
 *     "option-789": ["subheader"]
 *   }
 * }
 */
export type EditedContentReference = Record<string, Record<string, string[]>>;

export const editedContentReferenceSegment =
  stateSegmentWithReset<EditedContentReference>({});

editedContentReferenceSegment.debugLabel = 'editedContentReferenceSegment';
